﻿import { debounce, parseOptions } from './utils';

type SyncOptions = {
  targets: string[];
  delay?: number;
};

const syncElements = document.querySelectorAll<HTMLElement>('[data-sync]');

syncElements.forEach((syncElement) => {
  const raw = syncElement.dataset.sync;
  if (!raw) return;

  const options = parseOptions<SyncOptions>(raw, { targets: [], delay: 300 });

  if (!options.targets || !Array.isArray(options.targets) || options.targets.length === 0) {
    console.warn('Invalid or missing targets in data-sync:', raw);
    return;
  }

  const getSourceValue = (): string => {
    if (
      syncElement instanceof HTMLInputElement ||
      syncElement instanceof HTMLTextAreaElement ||
      syncElement instanceof HTMLSelectElement
    ) {
      return syncElement.value;
    }
    return syncElement.textContent ?? '';
  };

  const handler = debounce(() => {
    const value = getSourceValue();
    options.targets.forEach((selector) => {
      const target = document.querySelector<HTMLElement>(selector);
      if (!target) return;

      if (
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target instanceof HTMLSelectElement
      ) {
        target.value = value;
        // dispatch input event in case other logic listens for it
        target.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
      } else {
        target.textContent = value;
      }
    });
  }, Number(options.delay ?? 300));

  syncElement.addEventListener('keyup', handler);
});
